import React from "react";
import { Popconfirm } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import { finishRent, search } from "actions/chargers/activeRent/actions";

import CommonTable from "../../../lib/components/CommonTable";
import Filters from "./filters";

const PowerBanksRentActive = ({
                                list,
                                search,
                                finishRent,
                              }) => {
  const handleFinish = (item) => {
    finishRent(item.startStationQR, item.id, () => {
      search();
    });
  };

  const getColumns = () => [
    {
      id: "ID",
      Header: "#",
      accessor: "id",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        // <Link to={`/chargers/activeRents/${original.id}`}>
          original.id
        // </Link>
      )
    },
    {
      id: "user",
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "powerBank",
      Header: "Power bank",
      accessor: "powerBank"
    },
    {
      id: "startStationQR",
      Header: "Start Station QR",
      accessor: "startStationQR",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.startStationQR}`}>
          {original.startStationQR}
        </Link>
      ),
    },
    {
      id: "endStationQR",
      Header: "End Station QR",
      accessor: "endStationQR",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.endStationQR}`}>
          {original.endStationQR}
        </Link>
      ),
    },

    {
      id: "scan",
      Header: "Scan",
      Cell: ({ original }) => moment(original.scan)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "start",
      Header: "Start",
      Cell: ({ original }) => (original.start ? moment(original.start)
        .format("HH:mm YYYY-MM-DD") : "N/A"),
    },
    {
      id: "state",
      Header: "State",
      accessor: "state"
    },
    {
      id: "billingDetails.amount",
      Header: "Amount",
      accessor: "billingDetails.amount",
    },
    {
      id: "stationType",
      Header: "Station Type",
      accessor: "stationType",
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleFinish(original)}
          placement="top"
          okText="Yes"
          cancelText="Cancel"
        >
          <button
            className="btn btn-sm btn-warning"
            title="Finish"
          >
            Finish
          </button>
        </Popconfirm>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={search}
      FiltersComponent={Filters}
      searchHookProps={{
        size: 1000,
        sort: "start,DESC"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.powerBankActiveRent.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  search: bindActionCreators(search, dispatch),
  finishRent: bindActionCreators(finishRent, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PowerBanksRentActive);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/rent-active/index.js